function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import { find } from 'lodash';
import ContinentItem from "./continent-item/continent-item";
/**
 * @description group countries by continent
 * @param countries
 * @param carveouts
 * @param selectedCountries
 * @param territoryIdKey
 * @param continentNameKey
 */

export var groupByContinent = function groupByContinent(countries, selectedCountries, territoryIdKey, continentNameKey) {
  return countries.reduce(function (acc, country) {
    var continent = country[continentNameKey];

    var countryItem = _objectSpread({
      isSelected: Boolean(find(selectedCountries, function (_ref) {
        var id = _ref[territoryIdKey];
        return id === country[territoryIdKey];
      }))
    }, country);

    if (acc[continent]) acc[continent].push(countryItem);else acc[continent] = [countryItem]; // eslint-disable-line no-param-reassign

    return acc;
  }, {});
};

var TerritoriesList = function TerritoriesList(_ref2) {
  var onCountrySelect = _ref2.onCountrySelect,
      territories = _ref2.territories,
      selectedCountries = _ref2.selectedCountries,
      expandAll = _ref2.expandAll,
      theOtherListLabel = _ref2.theOtherListLabel,
      territoryIdKey = _ref2.territoryIdKey,
      territoryNameKey = _ref2.territoryNameKey,
      continentNameKey = _ref2.continentNameKey,
      formatMessage = _ref2.formatMessage,
      messages = _ref2.messages;
  // if list is empty, show default text
  if (!territories || territories.length === 0) return React.createElement("div", {
    className: "TerritoriesList-empty"
  }, React.createElement("p", null, formatMessage(messages.emptyListLabel)), React.createElement("p", null, formatMessage(messages.emptyListLabelFrom), React.createElement("b", null, " ".concat(theOtherListLabel, " ")), formatMessage(messages.emptyListDescription)));
  var groups = groupByContinent(territories, selectedCountries, territoryIdKey, continentNameKey);
  return React.createElement("div", {
    className: "TerritoriesList"
  }, Object.keys(groups).map(function (key, i) {
    return React.createElement(ContinentItem, {
      key: i,
      onCountrySelect: onCountrySelect,
      name: key,
      countries: groups[key],
      expandAll: expandAll,
      territoryIdKey: territoryIdKey,
      territoryNameKey: territoryNameKey
    });
  }));
};

TerritoriesList.propTypes = {
  onCountrySelect: PropTypes.func.isRequired,
  territories: PropTypes.array.isRequired,
  selectedCountries: PropTypes.array.isRequired,
  expandAll: PropTypes.bool,
  theOtherListLabel: PropTypes.string.isRequired,
  formatMessage: PropTypes.func.isRequired,
  messages: PropTypes.object.isRequired,
  territoryIdKey: PropTypes.string.isRequired,
  territoryNameKey: PropTypes.string.isRequired,
  continentNameKey: PropTypes.string.isRequired
};
export default TerritoriesList;